package com.islamicmedia.shared.domain.model

/**
 * Real user testimonials shown in the "TESTIMONIALS" marquee on the search screen (logged-out
 * visitors only). Text-only — no name, rating, or avatar.
 *
 * Lives in :shared because BOTH front-ends render the same belt (web `ReviewsBelt.kt`, mobile
 * `ReviewsBelt.kt`) and the two UI systems can't share composables. Keeping the copy here is the
 * only thing stopping the two lists from drifting apart the first time one is edited.
 */
object Testimonials {
    val REVIEWS: List<String> = listOf(
        "Jazakum Allahu khayran for creating such a valuable resource for Muslim families.",
        "Fitrah Filter has become an important part of how I choose books for my children.",
        "Fitrah Filter gives me greater confidence in the content I introduce into our home.",
        "The app is simple, clean, and very straightforward to use.",
        "I appreciate being able to save previous searches, which makes it easy to refer back to them.",
        "The concept itself fills a real need for Muslim families who want to make informed choices without having to research every book individually.",
        "I believe this is a very important app for families raising children with Islamic values.",
        "I wish this app was available when my kids were younger.",
        "Fitrah Filter has helped me make more informed decisions for my children with confidence.",
        "I highly recommend Fitrah Filter to any parent looking for guidance on age-appropriate, Islamically conscious content.",
        "Love this app! The layout is clean and easy to use, and the analysis is detailed and helpful.",
        "Searches are much faster now, and I love getting a notification when they're done.",
        "Jazakum Allahu khayran for all the effort behind this app! 1000% recommend 👌🏼",
        "I've been in need of something like this as it's been overwhelming doing the research myself.",
        "I love the waiting game & dhikr addition!!! Such a unique touch!",
        "Really deep. Really interesting. I love that if I just want to see a quick overview I can quickly see yellow, green, etc.",
    )
}
